export default __webpack_public_path__ + "static/media/tractor-telemetria.d525869a.svg";